import { render, staticRenderFns } from "./CtaBtn.vue?vue&type=template&id=2abc2352&"
import script from "./CtaBtn.vue?vue&type=script&lang=js&"
export * from "./CtaBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports